<template>
    <div
        class="position-relative"
        :style="style"
    >
        <v-icon
            name="radiobutton-empty"
            class="position-absolute abs-center opacity--70"
            :w="size"
        />

        <v-icon
            :name="icon"
            class="position-absolute abs-center"
            :w="size / 2.5"
        />
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: "info",
        },

        size: {
            type: Number,
            default: 50,
        },
    },

    computed: {
        style() {
            return {
                height: `${this.size}px`,
                width: `${this.size}px`,
            }
        },
    },
}
</script>
